module.exports = __webpack_public_path__ + "img/topicEnergy.de67dd72.svg";